<div class="videoPlayer" [ngClass]="cssClass" [style.height]='style.height+"px"'>
  @if (!isPaused && loading) {
    <loading class="pos-abs vh-center" [scale]="1" [stroke]='"#000"'></loading>
  }
  <div dblClick="dblClick" (onClick)="videoTogglePlayPause()" (onDoubleClick)="doubleClick()">
    <video #videoElement="" [src]="src" (canplaythrough)="loading = false" (play)="onVideoPlay()" (pause)="onVideoPause()" (ended)="videoEnd()" (timeupdate)="onTimeUpdate()" (loadeddata)="onLoaded?.emit()" [poster]="poster" [autoplay]="autoplay" [loop]="loop" disablepictureinpicture="disablepictureinpicture" controlslist="nodownload nofullscreen noremoteplayback" playsinline="playsinline" [style.height]='style.height+"px"' [preload]='"none"'></video>
    @if (isPaused || (autoplay && loading)) {
      <div class="play-button anim-fadeIn">
        <img src="/assets/images/play.png" />
      </div>
    }
  </div>
  @if (!hideAudioControl) {
    <div class="mute anim-fadeIn" (click)="muteToggle($event)">
      @if (videoElement.muted) {
        <em class="cs-icon-volume-off anim-fadeIn"></em>
        }@if (!videoElement.muted) {
        <em class="cs-icon-volume-on anim-fadeIn"></em>
      }
    </div>
  }
</div>
